import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@/assets/css/main.css'
// 공통으로 사용하는 컴포넌트
import secConfirm from '@/components/confirm'
import secLoading from '@/components/loading'
import '@/router/permission'

import VueGtag from 'vue-gtag'

Vue.use(VueGtag, { config: { id: 'UA-178276546-1' } })

Vue.config.productionTip = false

// 공통으로 사용하는 컴포넌트 등록
Vue.component('s-confirm', secConfirm)
Vue.component('s-loading', secLoading)

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')